import { Component, OnInit, OnDestroy, ViewContainerRef, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import {
  MatLegacyDialogRef as MatDialogRef,
  MatLegacyDialog as MatDialog,
} from '@angular/material/legacy-dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ResponsiveService } from 'src/app/shared/services/responsive.service';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { CustomViewService } from '../shared/services/custom-view.service';
import { SystemUserEulaService } from '../shared/services/system-user-eula.service';
import { CustomView } from '../shared/components/odata-filter/models/custom-view';
import { ViewContext } from '../shared/components/odata-filter/models/view-context';
import { PeopleFilterService } from '../people/people-filter.service';
import { TeamAddComponent } from '../teams/team-add/team-add.component';
import { WidgetsService } from '../shared/services/widgets.service';
import { WidgetModel } from '../shared/models/widget.model';
import { WidgetUIType } from '../shared/models/widget.type';

@Component({
  selector: 'app-home',
  templateUrl: 'home.component.html',
  styleUrls: ['home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  @ViewChild('sidenav', { static: true }) sidenav: MatSidenav;
  welcomeMessage = 'Welcome to Lineup!';
  teamDialogRef: MatDialogRef<TeamAddComponent>;
  toggleSidenavSub: Subscription;
  hasLoggedInSystemUserAcceptedLatestEulaSub: Subscription;

  widgetsUpdateDateTime = new Date();

  readonly HOME_PAGE_WIDGETS_UI_TYPE = WidgetUIType;
  homePageWidgets: WidgetModel[] = [];

  constructor(
    public auth: AuthService,
    public appConfig: AppConfigService,
    private viewContainerRef: ViewContainerRef,
    private dialog: MatDialog,
    private router: Router,
    private responsiveService: ResponsiveService,
    private peopleFilterService: PeopleFilterService,
    private customViewService: CustomViewService,
    private widgetsService: WidgetsService,
    private systemUserEulaService: SystemUserEulaService
  ) {}

  peopleViews: CustomView[] = [];
  loggedInSystemUserHasLatestEula: boolean;
  pageLoaded: boolean = false;

  ngOnInit() {
    this.customViewService.customViews.subscribe((result) => {
      if (result && result.length) {
        this.peopleViews = result.filter((x) => x.viewContext == ViewContext.People);
      }
    });

    this.hasLoggedInSystemUserAcceptedLatestEulaSub =
      this.systemUserEulaService.hasLoggedInSystemUserAcceptedLatestEula.subscribe((data) => {
        if (data == null) return;
        this.loggedInSystemUserHasLatestEula = data;
        this.pageLoaded = true;
      });

    if (this.appConfig.initialized) {
      this.widgetsService.getHomePageWidgets();
      this.widgetsService.homepageWidgets.subscribe((result) => {
        if (result) {
          this.homePageWidgets = result;
        }
      });
    }

    this.toggleSidenavSub = this.responsiveService.toggleSidenavEvent.subscribe(() => {
      this.sidenav.toggle();
    });
  }

  ngOnDestroy(): void {
    if (this.hasLoggedInSystemUserAcceptedLatestEulaSub) {
      this.hasLoggedInSystemUserAcceptedLatestEulaSub.unsubscribe();
    }
  }

  getHomePageWidgetInfo(widgetUIType: WidgetUIType): WidgetModel {
    return this.homePageWidgets.find((x) => x.widgetUIType == widgetUIType);
  }

  setFiltersAndGoToPeople(filterId: string) {
    let view = this.peopleViews.find((x) => x.id == filterId && x.isSystemView == true);
    if (view) {
      this.peopleViews.forEach((x) => (x.isSelected = false));
      this.peopleFilterService.selectView(view);
      this.router.navigate(['/people']);
    }
  }
  isAdmin() {
    return this.auth.adminLevelAccess;
  }

  openAddTeamDialog() {
    this.teamDialogRef = this.dialog.open(TeamAddComponent, {
      viewContainerRef: this.viewContainerRef,
    });

    this.teamDialogRef.afterClosed().subscribe((teamId) => {
      if (teamId) {
        this.router.navigate(['/teams/' + teamId]);
      }
      this.teamDialogRef = null;
    });
  }
}
